<template>
  <div>
    <b-modal id="order-details" size="lg" title="Order Details" hide-footer class="order-details-modal" ref="ViewOrder"
      no-close-on-backdrop no-close-on-esc centered @show="onShowModal">
      <b-container fluid class="px-0" v-if="orderDetails">
        <b-row no-gutters>
          <b-col cols="5">
            <div class="order-details-left">
              <h1>Ordered by</h1>
              <h2>{{ orderDetails.customer_name }}</h2>
              <h1 class="mt-4">Mobile Number</h1>
              <h2>0{{ orderDetails.mobile }}</h2>
              <h1 class="mt-4">Brand Branch</h1>
              <h2>
                {{ orderItemDetails ? orderItemDetails.brand_name : "" }} ({{
                  orderItemDetails ? orderItemDetails.branch : ""
                }})
              </h2>
              <h1 class="mt-4">Transaction ID</h1>
              <h2>{{ orderDetails.transaction_no }}</h2>
              <h1 class="mt-4">Date Ordered</h1>
              <h2>
                {{ formatDate(orderDetails.created_at, "dateOrdered") }}
              </h2>
              <h1 class="mt-4">Delivery Type</h1>
              <h2>
                {{ orderItemDetails ? orderItemDetails.delivery_type : "" }}
                {{
                  orderItemDetails
                    ? orderItemDetails.pickup_datetime
                      ? `(${formatDate(
                        orderItemDetails.pickup_datetime,
                        "delivery"
                      )})`
                      : ""
                    : ""
                }}
              </h2>
              <ProofOfDeliveryComponent :grabDelivery="grabDelivery" />
              <h1 class="mt-4">Preparation Time</h1>
              <b-form-select v-if="orderItemDetails" style="width: 200px" v-model="orderItemDetails.preparation_time"
                :options="preparationTimeOptions"></b-form-select>
              <h1 class="mt-4">Delivery Address</h1>
              <h2>
                {{ orderItemDetails ? orderItemDetails.delivery_address : "" }}
              </h2>
              <h2 v-if="orderItemDetails && orderItemDetails.delivery_address_details
              ">
                {{ orderItemDetails.delivery_address_details }}
              </h2>
              <hr />
              <h5 class="text-primary font-weight-bold">Payment Details</h5>
              <h1 class="mt-4">Mode of Payment</h1>
              <h2>{{ orderDetails.payment_type | modeOfPayment }}</h2>
              <template v-if="orderDetails.payment_type == 'BT' &&
                orderDetails.deposit_slips.length != 0">
                <h1 class="mt-4">Bank</h1>
                <h2>
                  {{ showRecentBank(orderDetails.deposit_slips) }}
                </h2>
                <h1 class="mt-4">Reference Number</h1>
                <h2>
                  {{ showRecentReferenceNumber(orderDetails.deposit_slips) }}
                </h2>
                <div v-for="(depositSlip, index) in orderDetails.deposit_slips" :key="index">
                  <h1 class="mt-4">Attachment</h1>
                  <div class="attachment-container organization-content p-0">
                    <div role="tablist">
                      <b-card no-body class="mb-3">
                        <b-card-header header-tag="header" class="p-0" role="tab">
                          <div class="brand-header">
                            <b-row no-gutters>
                              <b-col>
                                <p class="d-inline-block mb-0 align-middle px-3 pt-3 pb-2 image-name" @click="
                                  showDepositSlipImage(depositSlip.image_name)
                                  ">
                                  <img style="position: relative; margin-top: -5px"
                                    src="@/assets/images/icons/attach.svg" alt="Deposit Slip" />{{
                                      depositSlip.image_name.substr(
                                        depositSlip.image_name.lastIndexOf("/") +
                                        1
                                      )
                                    }}
                                  <br />
                                  <span class="uploaded mb-0">Uploaded
                                    {{
                                      formatDate(
                                        depositSlip.created_at,
                                        "uploaded"
                                      )
                                    }}</span>
                                </p>
                                <div class="px-3 pb-3">
                                  <template v-if="depositSlip.status == 'approved'">
                                    <span class="status-approved mt-0">Approved</span>
                                  </template>
                                  <template v-else-if="depositSlip.status == 'rejected'">
                                    <span class="status-rejected mt-0">Rejected</span>
                                  </template>
                                </div>
                              </b-col>
                              <b-col cols="1" class="text-center action-button" v-b-toggle="`attachment-${index}`">
                                <img src="@/assets/images/icons/dropdown.svg" alt="Collapse Icon"
                                  class="d-inline-block when-closed icon" />
                                <img src="@/assets/images/icons/dropdown.svg" alt="Expand Icon"
                                  class="d-inline-block when-opened icon expand" />
                              </b-col>
                            </b-row>
                          </div>
                        </b-card-header>
                        <b-collapse :id="`attachment-${index}`" visible accordion="attachment-accordion"
                          role="tabpanel">
                          <b-card-body class="branch p-3" style="border-top: 1px solid #eaeaea">
                            <b-row no-gutters v-bind:class="{
                              'mb-3': depositSlipStatus != false,
                            }">
                              <b-col class="pr-2">
                                <b-button class="deposit-success-button" v-bind:class="{
                                  active: depositSlipStatus == true,
                                }" block variant="success" @click="updateDepositSlipStatus(true)">Approve</b-button>
                              </b-col>
                              <b-col class="pl-2">
                                <b-button class="deposit-reject-button" v-bind:class="{
                                  active: depositSlipStatus == false,
                                }" block variant="danger" @click="updateDepositSlipStatus(false)">Reject</b-button>
                              </b-col>
                            </b-row>
                            <template v-if="!depositSlipStatus && depositSlipStatus != null
                            ">
                              <b-form-group label-for="description" :label="descriptionLabel"
                                class="secondary-label deposit-slip-label" v-bind:class="{
                                  'deposit-slip-label-mid':
                                    form.description.length >= 10,
                                  'deposit-slip-label-max':
                                    form.description.length == maxDescription,
                                }" description="Note: This will notify customer via push notification or sms">
                                <b-form-textarea ref="RejectReason" placeholder="Please enter a reason"
                                  :maxlength="maxDescription" v-model="form.description" :rows="6" :max-rows="6"
                                  :state="formDescriptionState">
                                </b-form-textarea>
                              </b-form-group>
                            </template>
                            <b-row no-gutters>
                              <b-col>
                                <b-button :disabled="loading" class="deposit-update-button" block variant="primary"
                                  @click="
                                    updateDepositSlipConfirmation(
                                      depositSlip.uuid
                                    )
                                    ">UPDATE</b-button>
                              </b-col>
                            </b-row>
                          </b-card-body>
                        </b-collapse>
                      </b-card>
                    </div>
                  </div>
                </div>
              </template>
              <template v-else-if="orderDetails.payment_type == 'BT' &&
                orderDetails.deposit_slips.length == 0
              ">
                <h1 class="mt-4">Bank</h1>
                <h2>-</h2>
                <h1 class="mt-4">Reference Number</h1>
                <h2>-</h2>
                <h1 class="mt-4">Attachment</h1>
                <div class="no-uploaded-file-container p-2">
                  <p class="mb-0">
                    <img style="position: relative; margin-top: -3px" src="@/assets/images/icons/attach.svg"
                      alt="Attachment" />
                    No uploaded file
                  </p>
                </div>
              </template>
              <h1 class="mt-3">Payment Breakdown</h1>
              <div>
                <div v-for="(order, index) in orderDetails.orders" :key="'orders-' + index" :class="{
                  'border-top': index > 0,
                  'py-3': index > 0,
                  'pb-3': index === 0,
                }">
                  <b-row class="mb-2">
                    <b-col>
                      {{ order.brand_name }} ({{ order.branch}})
                      <template v-if="(orderItemDetails &&
                        orderItemDetails.brand_name != order.brand_name &&
                        orderItemDetails &&
                        orderItemDetails.branch != order.branch) ||
                        (orderItemDetails &&
                          orderItemDetails.brand_name == order.brand_name &&
                          orderItemDetails &&
                          orderItemDetails.branch != order.branch)
                      ">
                        <div><small>Other Purchases</small></div>
                      </template>
                    </b-col>
                    <b-col class="text-right">
                      Php {{ order.order_item_total_amount | regularPrice }}
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col><h1>Subtotal</h1></b-col>
                    <b-col class="text-right">
                      <h1>Php {{ order.order_amount | regularPrice }}</h1>
                    </b-col>
                  </b-row>
                  <b-row no-gutters v-for="(fee, index) in order.fees" :key="'fees-' + index">
                    <b-col><h1>{{ fee.name }}</h1></b-col>
                    <b-col class="text-right">
                      <h1>
                        <template v-if="fee.name === 'Delivery Fee'">
                          <span 
                            v-if="get(orderDetails, 'voucher_info.is_free_delivery', false) || get(orderDetails, 'voucher_info.is_delivery_discount_enable', false)" 
                            :class="['font-weight-bold', { 'text-line-through': get(orderDetails, 'voucher_info.is_free_delivery', false) }]"
                          >
                            Php {{ fee.value | regularPrice }}
                          </span>
                          <span v-else class="font-weight-bold">
                            <template v-if="fee.calculated_amount">
                              Php {{ fee.calculated_amount | regularPrice }}
                            </template>
                            <template v-else>
                              FREE  
                            </template>
                          </span>
                        </template> 
                      </h1>
                    </b-col>
                  </b-row>
                  <b-row v-if="isMedPadalaCredits">
                    <b-col>
                      <h1 class="text-success font-weight-bold">MEDPadala</h1>
                    </b-col>
                    <b-col class="text-right">
                      <h1 class="text-success font-weight-bold">
                        - Php {{
                            orderDetails.customizations.find(
                              (customization) =>
                                customization.type === "med-padala"
                            ).values.amount | regularPrice
                          }}
                      </h1>
                    </b-col>
                  </b-row> 
                  <b-row v-if="orderDetails.points_used && orderDetails.points_value">
                    <b-col><h1 class="text-success font-weight-bold">Points Redeemed: {{ orderDetails.points_used }}</h1></b-col>
                    <b-col class="text-right">
                      <h1 class="text-success font-weight-bold">- Php {{ Number(orderDetails.points_value) | regularPrice }}</h1>
                    </b-col>
                  </b-row>
                  <b-row v-if="orderDetails.voucher_info">
                    <b-col><h1 class="text-success font-weight-bold text-break">Promo: {{ orderDetails.voucher_code }}</h1></b-col>
                    <b-col class="text-right">
                      <h1 class="text-success font-weight-bold">
                        <template v-if="get(orderDetails, 'voucher_info.is_free_delivery', false)">
                          FREE DELIVERY
                        </template>
                        <template v-else>
                          - Php {{ Number(orderDetails.voucher_amount) | regularPrice }}
                        </template>
                      </h1>
                    </b-col>
                  </b-row>
                  <b-row v-if="Boolean(specialDiscount)">
                    <b-col><h1 class="text-success font-weight-bold text-break">Special Discount</h1></b-col>
                    <b-col class="text-right">
                      <h1 class="text-success font-weight-bold">- Php {{ Number(specialDiscount) | regularPrice }}</h1>
                    </b-col>
                  </b-row>
                </div>
                <div class="py-2 border-top">
                  <b-row>
                    <b-col>
                      <p class="mb-0 font-weight-bold" style="font-size: 18px;">Total</p>
                    </b-col>
                    <b-col class="text-right">
                      <p class="mb-0 font-weight-bold" style="font-size: 18px;">
                        Php {{ orderDetails.computed_total | regularPrice }}
                      </p>
                    </b-col>
                  </b-row>
                </div>
                <div v-if="pointsEarned" class="my-4">
                  <PointsEarned :points="pointsEarned" :is-order-completed="isOrderCompleted" />
                </div>
              </div>
              <div class="confirmation-container p-3" v-if="depositSlipConfirmation">
                <b-row no-gutters>
                  <b-col>
                    <p class="mb-0">
                      <img src="@/assets/images/icons/confirm.svg" class="mr-1" alt="Confirmation" />
                      Are you sure you want to update?
                    </p>
                  </b-col>
                </b-row>
                <b-row no-gutters>
                  <b-col class="text-right">
                    <b-button :disabled="loading" class="confirmation-button" style="color: #ff8b20"
                      variant="outline-secondary" @click="updateDepositSlip()">Yes</b-button>
                    <b-button :disabled="loading" class="confirmation-button" variant="outline-secondary"
                      @click="cancelUpdateConfirmation()">No</b-button>
                  </b-col>
                </b-row>
              </div>
            </div>
          </b-col>
          <b-col>
            <div class="order-details-right organization-content">
              <div class="order-id">
                Order ID {{ orderItemDetails ? orderItemDetails.order_no : "" }}
              </div>
              <div role="tablist" v-if="orderItemDetails">
                <b-card no-body class="mb-3" v-for="(order_item, index) in orderItemDetails.order_items"
                  :key="`order_item-${index}`">
                  <b-card-header header-tag="header" class="p-0" role="tab">
                    <div class="container py-3 brand-header">
                      <b-row no-gutters>
                        <b-col class="text-break text-primary">
                            {{ order_item.product_name }}
                            {{ returnVariation(order_item.variation_desc) }}
                        </b-col>
                        <b-col cols="2" class="text-center">
                          x{{ Math.ceil(order_item.quantity) }}
                        </b-col>
                        <b-col cols="3" class="text-right">
                          Php
                          {{
                            (order_item.item_amount *
                              parseInt(order_item.quantity))
                            | regularPrice
                          }}
                        </b-col>
                        <b-col cols="1" class="text-right action-button"
                          v-b-toggle="'branchAccordion' + index">
                          <img src="@/assets/images/icons/dropdown.svg" alt="Collapse Icon"
                            class="d-inline-block when-closed icon" />
                          <img src="@/assets/images/icons/dropdown.svg" alt="Expand Icon"
                            class="d-inline-block when-opened icon expand" />
                        </b-col>
                      </b-row>
                    </div>
                  </b-card-header>
                  <b-collapse :id="'branchAccordion' + index" visible accordion="my-accordion" role="tabpanel">
                    <b-card-body class="branch p-3" style="border-top: 1px solid #eaeaea; overflow-x: auto">
                      <b-row no-gutters>
                        <b-col>
                          <p>
                            <span class="label">Category:</span>
                            {{ order_item.category_name }}
                          </p>
                          <p class="d-none">Item Availability</p>
                        </b-col>
                        <b-col>
                          <p>
                            <span class="label">SKU:</span> {{ order_item.sku }}
                          </p>
                        </b-col>
                      </b-row>
                      <b-row no-gutters>
                        <b-col>
                          <p>
                            <span class="label">Special Instructions:</span>
                          </p>
                          <p>{{ order_item.instructions }}</p>
                        </b-col>
                      </b-row>
                      <template v-if="order_item.add_ons.length > 0">
                        <b-row no-gutters>
                          <b-col>
                            <p><span style="color: #ff8a00">Add Ons:</span></p>
                          </b-col>
                        </b-row>
                        <b-row no-gutters class="text-muted">
                          <b-col>
                            <p>Name</p>
                          </b-col>
                          <b-col class="text-center">
                            <p>Total Quantity</p>
                          </b-col>
                          <b-col>
                            <p>Price</p>
                          </b-col>
                          <b-col>
                            <p>SKU</p>
                          </b-col>
                        </b-row>
                        <b-row no-gutters v-for="(add_ons, add_on_index) in order_item.add_ons" :key="add_on_index">
                          <b-col>
                            <p class="mb-2">{{ add_ons.name }}</p>
                          </b-col>
                          <b-col class="text-center">
                            <p class="mb-2">
                              x{{ parseInt(order_item.quantity) }}
                            </p>
                          </b-col>
                          <b-col>
                            <template v-if="add_ons.is_free">
                              <p class="mb-2">Free</p>
                            </template>
                            <template v-else>
                              <p class="mb-2">
                                {{
                                  (parseInt(order_item.quantity) *
                                    parseFloat(add_ons.price))
                                  | regularPrice
                                }}
                              </p>
                            </template>
                          </b-col>
                          <b-col>
                            <p class="mb-2">{{ add_ons.sku }}</p>
                          </b-col>
                        </b-row>
                      </template>
                    </b-card-body>
                  </b-collapse>
                </b-card>
                <b-card>
                  <b-row class="mb-2" no-gutters>
                    <b-col>
                      <p class="label">Other Notes</p>
                      <p>{{ orderDetails.notes }}</p>
                    </b-col>
                  </b-row>
                </b-card>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row no-gutters class="psuedo-modal-footer" v-if="orderItemDetails">
          <b-col cols="1" class="d-flex align-items-center">
            <p style="margin-top: 7px;">Status</p>
          </b-col>
          <b-col cols="2" v-if="orderStatus">
            <b-dropdown
              block
              variant="light"
              class="w-100"
              menu-class="w-100"
              toggle-class="bg-white border text-left"
            >
            <template slot="button-content">
              <i class="bi bi-circle-fill mr-1" :class="`text-${orderStatus.value}`" aria-hidden="true"></i> 
              {{ orderStatus.text }}
            </template>
              <b-dropdown-item 
                v-for="(status, index) in statusDropdownOptions" 
                :key="index"
                @click="orderStatus = status" 
              >
                {{ status.text }}
              </b-dropdown-item>
            </b-dropdown>
          </b-col>
          <b-col class="text-right">
            <b-button variant="primary" class="update-order-button" @click="
              updateStatus(
                orderDetails,
                orderStatus.value
              )
              " :disabled="loading ||
                checkApprovedDepositSlips(
                  orderDetails.payment_type,
                  orderDetails.deposit_slips
                )
                ">UPDATE ORDER</b-button>
          </b-col>
        </b-row>
      </b-container>
      <template slot="modal-header-close">
        <span @click="closeModal">×</span>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { Decimal } from "decimal.js";
import ProofOfDeliveryComponent from "./ProofOfDeliveryComponent.vue";
import PointsEarned from "./PointsEarned.vue";
import _ from "lodash";

export default {
  name: "NewProduct",
  props: ["status", "orderUuid"],
  components: { ProofOfDeliveryComponent, PointsEarned },
  data() {
    return {
      selected: null,
      options: [
        { value: "pending", text: "Pending" },
        { value: "cancel", text: "Cancel" },
      ],
      preparationTimeOptions: [
        { value: 15, text: "15 minutes" },
        { value: 30, text: "30 minutes" },
        { value: 45, text: "45 minutes" },
        { value: 60, text: "60 minutes" },
      ],
      depositSlipStatus: null,
      depositSlipConfirmation: false,
      depositSlipUuid: null,
      form: {
        description: "",
      },
      maxDescription: 100,
      formDescriptionState: null,
      orderStatus: null,
      get: _.get
    };
  },
  computed: {
    ...mapState("estoreOrders", [
      "loading",
      "errors",
      "modal",
      "orderTransactionUuid",
      "statusSearchOptions",
      "pagination",

    ]),
    ...mapGetters({
      orderDetails: "estoreOrders/orderDetails",
    }),
    statusDropdownOptions() {
      return this.statusSearchOptions.filter(({ text }) => text !== 'All Status');
    },
    descriptionLabel: {
      get: function () {
        if (this.form.description != null) {
          return this.form.description.length + " / " + this.maxDescription;
        }
        return "0 / " + this.maxDescription;
      },
    },
    isMedPadalaCredits() {
      return (
        Object.keys(this.orderDetails).includes("customizations") &&
        this.orderDetails.customizations
          .map((customization) => customization.type)
          .includes("med-padala")
      );
    },
    orderItemDetails: {
      get() {
        return this.orderDetails
          ? this.orderDetails.orders.find(
            (order) => order.uuid === this.orderUuid
          )
          : null;
      },
    },
    grabDelivery: {
      get() {
        return _.get(this.orderItemDetails, "grab_delivery", {}) || {};
      },
      set(data) {
        return data;
      }
    },
    specialDiscount: {
      get() {
        let amount = 0;
        _.get(this.orderDetails, "orders", []).forEach(
          ({ special_discount_approved, special_discount_computed_amount }) => {
            if (special_discount_approved/1) amount += Number(special_discount_computed_amount)
            else amount += 0
          }
        );
        return amount;
      },
      set(value) {
        return value;
      }
    },
    pointsEarned() {
      return _.get(this.orderDetails, "points_earned");
    },
    isOrderCompleted() {
      return ["delivered", "claimed"].includes(_.get(this.orderItemDetails, "status", ""));
    }
      
  },
  methods: {
    onShowModal() {
      this.orderStatus = this.statusDropdownOptions.find(
        ({ value }) => value === this.orderItemDetails.status
      );
    },
    updateStatus(data, status) {
      let param = {
        uuid: this.orderUuid,
        payload: {
          status: status,
          mobile_number: data.mobile,
          fullname: data.customer_name,
          preparation_time: data.orders.find(
            (order) => order.uuid === this.orderUuid
          ).preparation_time,
        },
      };

      let _this = this;
      this.$store
        .dispatch("estoreOrders/updateStatus", param)
        .then(function () {
          if (_this.errors == null) {
            _this.$parent.getOrders(_this.pagination.currentPage);
            _this.closeModal();
          }
        });
    },
    returnVariation(variationDesc) {
      let variation = "";
      let parsedVariationDesc = JSON.parse(variationDesc);
      if (parsedVariationDesc.length != 0) {
        for (const variationDescription of parsedVariationDesc) {
          variation += " - " + variationDescription.value;
        }
        return "(" + variation.substring(3) + ")";
      }
    },
    closeModal: function () {
      this.$store.commit("estoreOrders/setModal", {
        type: "view_order",
        status: false,
      });
    },
    formatDate: function (date, type) {
      if (type == "uploaded") {
        return this.$moment(date).format("LLL");
      } else if (type == "dateOrdered") {
        return this.$moment(date).format("MM/DD/YYYY, hh:mm A");
      } else if (type == "delivery") {
        return this.$moment(date).format("MMMM DD, YYYY, hh:mm A");
      }
    },
    async updateDepositSlip() {
      let param = {
        uuid: this.depositSlipUuid,
        payload: {
          status: this.depositSlipStatus ? "approved" : "rejected",
          remarks: this.form.description == null ? "" : this.form.description,
        },
      };
      let _this = this;
      await this.$store
        .dispatch("estoreOrders/updateDepositSlipStatus", param)
        .then(() => {
          if (_this.errors == null) {
            this.depositSlipConfirmation = false;
            this.form.description = "";
            this.depositSlipStatus = null;
            this.formDescriptionState = null;
            _this.$store.dispatch("estoreOrders/getOrderTransactionDetails", {
              uuid: this.orderTransactionUuid,
            });
          }
        });
    },
    updateDepositSlipStatus(status) {
      this.depositSlipStatus = status;
    },
    updateDepositSlipConfirmation(uuid) {
      this.depositSlipUuid = uuid;
      if (this.depositSlipStatus != null) {
        if (this.depositSlipStatus == true) {
          this.depositSlipConfirmation = true;
        } else {
          if (this.form.description.length > 0) {
            this.formDescriptionState = true;
            this.depositSlipConfirmation = true;
          } else {
            this.formDescriptionState = false;
          }
        }
      }
    },
    showDepositSlipImage(image) {
      this.$store.commit("estoreOrders/setModal", {
        type: "view_deposit_slip_image",
        status: true,
      });
      this.$store.commit("estoreOrders/setDepositSlipImage", image);
    },
    cancelUpdateConfirmation() {
      this.depositSlipConfirmation = false;
    },
    calculateTotal(transactionOrders = null, promo = null, fees = null) {
      if (transactionOrders != null && fees != null) {
        const re = new RegExp("^-?\\d+(?:.\\d{0," + (2 || -1) + "})?");
        let totalTransactionOrders = 0;
        let formattedPromo = 0;
        if (promo != null) {
          formattedPromo = Number(promo.value.toString().match(re)[0]);
        }

        for (const transactionOrder of transactionOrders) {
          totalTransactionOrders += parseFloat(
            transactionOrder.order_item_total_amount
          );
        }

        totalTransactionOrders = new Decimal(
          Number(totalTransactionOrders.toString().match(re)[0])
        );

        if (promo != null && promo.value_type == "%") {
          formattedPromo = totalTransactionOrders
            .dividedBy(100)
            .times(formattedPromo);
        }
        formattedPromo = Number(formattedPromo.toString().match(re)[0]);
        let total = totalTransactionOrders.minus(formattedPromo);
        total = total < 0 ? 0 : total;
        let feesTotal = 0;
        for (const fee of fees) {
          if (fee.value_type == "%") {
            feesTotal += (totalTransactionOrders / 100) * fee.value;
          } else {
            feesTotal += parseFloat(fee.value);
          }
        }
        feesTotal = Number(feesTotal.toString().match(re)[0]);
        total = new Decimal(Number(total.toString().match(re)[0]));
        return total.plus(feesTotal);
      }
    },
    calculateVoucherAmount(transactionOrders = null, promo = null) {
      if (transactionOrders != null && promo != null) {
        const re = new RegExp("^-?\\d+(?:.\\d{0," + (2 || -1) + "})?");
        let totalTransactionOrders = parseFloat(
          transactionOrders
            .map((order) => order.order_amount)
            .reduce((currVal, nextVal) => Number(currVal) + Number(nextVal))
        );
        let formattedPromo = Number(promo.value.toString().match(re)[0]);

        totalTransactionOrders = new Decimal(
          Number(totalTransactionOrders.toString().match(re)[0])
        );

        return promo.value_type === "%"
          ? totalTransactionOrders.dividedBy(100).times(formattedPromo)
          : formattedPromo;
      }
    },
    calculateFee(transactionOrders = null, fee = null) {
      if (transactionOrders != null && fee != null) {
        const re = new RegExp("^-?\\d+(?:.\\d{0," + (2 || -1) + "})?");
        let totalTransactionOrders = 0;
        for (const transactionOrder of transactionOrders) {
          totalTransactionOrders += parseFloat(
            transactionOrder.order_item_total_amount
          );
        }
        totalTransactionOrders = new Decimal(
          Number(totalTransactionOrders.toString().match(re)[0])
        );
        if (fee.value_type == "%") {
          return totalTransactionOrders.dividedBy(100).times(fee.value);
        } else {
          return fee.value;
        }
      }
    },
    checkApprovedDepositSlips(modeOfPayment = null, depositSlips = null) {
      if (modeOfPayment != null && depositSlips != null) {
        if (modeOfPayment == "BT") {
          const checkApprovedStatus = (obj) => obj.status === "approved";
          return !depositSlips.some(checkApprovedStatus);
        } else {
          return false;
        }
      }
    },
    showRecentBank(depositSlips) {
      let depositSlip = depositSlips[depositSlips.length - 1];
      if (depositSlip.bank_details != null) {
        return depositSlip.bank_details.bank != "" || null
          ? depositSlip.bank_details.bank
          : "-";
      } else {
        return "-";
      }
    },
    showRecentReferenceNumber(depositSlips) {
      let depositSlip = depositSlips[depositSlips.length - 1];
      return depositSlip.reference_no != "" || null
        ? depositSlip.reference_no
        : "-";
    },
  },
  watch: {
    status: function (status) {
      if (status === true) {
        this.$refs.ViewOrder.show();
        this.$store.commit("estoreOrders/errors", null);
      } else {
        this.$refs.ViewOrder.hide();
      }
    },
  },
  filters: {
    modeOfPayment: function (modeOfPayment) {
      if (modeOfPayment == "COD") {
        return "Cash On Delivery";
      } else if (modeOfPayment == "BT") {
        return "Bank Transfer";
      } else if (modeOfPayment == "CC") {
        return "Credit Card";
      } else if (modeOfPayment == "CP") {
        return "Cash Payment";
      } else if (modeOfPayment == "MEDPADALA-WALLET") {
        return "Promotional";
      } else if (modeOfPayment == "QRPH_XENDIT") {
        return "QR_PH_XENDIT";
      } else if (modeOfPayment == "UNIONBANK_XENDIT") {
        return "UNIONBANK_-_DIRECT_DEBIT_XENDIT";
      } else {
        return modeOfPayment;
      }
    },
    regularPrice: function (value = null) {
      if (value != null) {
        const re = new RegExp("^-?\\d+(?:.\\d{0," + (2 || -1) + "})?");
        const sNumber = Number(value.toString().match(re)[0]);
        let regularPrice = new Decimal(sNumber);
        return Number(regularPrice).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
      }
    },
    truncate: function (text, length) {
      let imageFormat = text.substr(text.length - 4);
      return text.length > length ? text.slice(0, length) + imageFormat : text;
    },
  },
};
</script>
